import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ImagePopup from "../ImagePopup/ImagePopup.js";
import PopupTemplateOne from "../PopupTemplateOne/PopupTemplateOne.js";

function PopupManager() {
    const [show, setShow] = useState(false);
    const isTouchScreen = useSelector((state) => state.utilities.isTouchScreen);

    const popup = useSelector((state) => state.content.options);
    const popupActive = useSelector(
        (state) => state.content.options.popup_active
    );
    const popupType = useSelector((state) => state.content.options.popup_type);

    function closePopup() {
        setShow(false);
    }

    useEffect(() => {
        setTimeout(() => {
            setShow(true);
        }, 2000);
    }, []);

    if (typeof popup != "undefined" && show && popupActive) {
        if (popupType) return <PopupTemplateOne close={closePopup} />;
        else return <ImagePopup close={closePopup} />;
    } else return <div></div>;
}

export default PopupManager;
